const MIN_PANEL_SIZE = 40;

export function getSheetSize(sheet, sourcePanel) {
  const length = Math.max(
    Number(sheet?.sheetLength ?? sourcePanel?.length) || 2440,
    MIN_PANEL_SIZE,
  );
  const width = Math.max(
    Number(sheet?.sheetWidth ?? sourcePanel?.width) || 1220,
    MIN_PANEL_SIZE,
  );
  return { length, width };
}

export function buildSheetConfig(sheetLength, sheetWidth, margin, kerf, rotationAllowed) {
  const length = Math.max(Number(sheetLength) || 0, MIN_PANEL_SIZE);
  const width = Math.max(Number(sheetWidth) || 0, MIN_PANEL_SIZE);
  const safeMargin = Math.max(Number(margin) || 0, 0);
  const safeKerf = Math.max(Number(kerf) || 0, 0);
  const availableLength = Math.max(length - safeMargin * 2, 0);
  const availableWidth = Math.max(width - safeMargin * 2, 0);

  return {
    sheetLength: length,
    sheetWidth: width,
    availableLength,
    availableWidth,
    margin: safeMargin,
    kerf: safeKerf,
    rotationAllowed: Boolean(rotationAllowed),
  };
}
